import styled from 'styled-components'
import { textSizeStyles, textWeightStyles } from './textStyles'

export const BulletList = styled.ul`
    list-style-type: disc; /* Default bullet point style */
    margin: 0;
    padding-left: 20px; /* Indentation */
    margin-left: 8px;

    ${textSizeStyles['medium']}
    ${textWeightStyles['regular']}
`
